<div class="row form-property  {{property?.styleClass ? property.styleClass : ''}}">
  <div class="col-lg-{{tooltip?10:12}}"
       [ngClass]="{'no-padding-right':tooltip}">
    <span class="p-float-label" [ngClass]="{'has-validation-icon': notValid}">
      <p-password 
                  [id]="name"
                  #pPassword
                  [ngModel]="value"
                  class="p-filled p-password-width p-password-full-width"
                  (ngModelChange)="change($event)"
                  [disabled]="readonly"
                  [ngClass]="{'disabled':readonly, 'property-invalid':notValid}"
                  [toggleMask]="true"
                  [feedback]="property.feedback">
      </p-password>
      <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':notValid}">{{label}}
      </label>

      <span *ngIf="notValid"
            class="form-error"
            style="position: absolute; right: 10px; top: 8px; z-index: 10;"
            pTooltip="{{property.validationMessage}}">
        <i class="fas fa-info-circle fa-2x form-valid-icon error-color"></i>
      </span>
    </span>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
